// extracted by mini-css-extract-plugin
module.exports = {"chatMessages":"Chat_chatMessages__buxYH","chatContainer":"Chat_chatContainer__Je78A"};